export default function App() {
  return (
    <iframe
      src="/optimaflow.html"
      title="OptimaFlow — Système. Automatisation. Résultat."
      data-testid="optimaflow-frame"
      style={{ position: "fixed", inset: 0, width: "100%", height: "100%", border: "none", background: "#0A0D14" }}
    />
  );
}
